/** Queries for 'Grana Privrede' */

import { tag } from 'api/rtkTags'
// eslint-disable-next-line
import { initialEconomyBranch } from 'constants/initialValues'
import { label } from 'constants/labels'

export const queryGetPagedEconomyBranches = (pageNumber, pageSize, options = {}) => {
  return {
    query: {
      name: 'data',
      mode: 'page',
      type: 'granaPrivrede',
      data: {
        pageNumber,
        pageSize,
        options: {
          ...options,
          order: [['naziv', 'ASC']]
        }
      }
    },
    providesTags: {
      type: tag.economyBranch
    }
  }
}
export const queryGetAllCategoriesWhereProductId = (options = {}, postscriptQuery) => {
  return {
    query: {
      name: 'data',
      mode: 'all',
      type: 'proizvod_search',
      data: {
        options: {
          ...options,
          distinct: true,
          order: [['naziv', 'ASC']]
        },
        postscriptQuery
      }
    },
    providesTags: {
      type: tag.category
    }
  }
}
export const queryGetAllEconomyBranches = () => {
  return {
    query: {
      name: 'data',
      mode: 'all',
      type: 'granaPrivrede',
      data: {
        options: {
          order: [['naziv', 'ASC']]
        }
      }
    },
    providesTags: {
      type: tag.economyBranch
    }
  }
}

/**
 * @param {initialEconomyBranch} data
 */
export const queryAddEconomyBranch = data => {
  return {
    query: {
      name: 'data',
      mode: 'new',
      type: 'granaPrivrede',
      data: { values: data }
    },
    invalidatesTags: [tag.economyBranch],
    successMsg: label.successMsgCreate + ' ' + label.msgEconomyBranch
  }
}

/**
* @param {initialEconomyBranch} data
@param {string} id
*/
export const queryUpdateEconomyBranch = (data, id) => {
  return {
    query: {
      name: 'data',
      mode: 'update',
      type: 'granaPrivrede',
      data: {
        values: data,
        options: {
          where: {
            id
          }
        }
      }
    },
    invalidatesTags: [tag.economyBranch],
    successMsg: label.successMsgEdit + ' ' + label.msgEconomyBranch
  }
}
/**
@param {string} id
*/
export const queryDeleteEconomyBranch = id => {
  return {
    query: {
      name: 'data',
      mode: 'delete',
      type: 'granaPrivrede',
      data: {
        options: {
          where: { id }
        }
      }
    },
    invalidatesTags: [tag.economyBranch],
    successMsg: label.successMsgDelete + ' ' + label.msgEconomyBranch
  }
}
